/**
 * Zeit-Fortschritt der Übersicht (D-00b): wie weit sind Woche, Monat, Jahr und
 * Schulhalbjahr? Rein und getestet. Anteile 0..1 mit Text („Tag 5 von 7“).
 */
import { differenceInDays, endOfMonth, startOfMonth, startOfWeek } from '@/lib/datetime';
import type { LocalDate } from '@/domain/types';

export interface FortschrittBalken { key: 'woche' | 'monat' | 'jahr' | 'halbjahr'; label: string; anteil: number; text: string }

const tage = (von: LocalDate, bis: LocalDate) => differenceInDays(von, bis) + 1;

/** Das Schulhalbjahr, in dem `heute` liegt: 1. Halbjahr 1.8.-31.1., 2. Halbjahr 1.2.-31.7. */
export function schulhalbjahr(heute: LocalDate): { nr: 1 | 2; von: LocalDate; bis: LocalDate } {
  const j = Number(heute.slice(0, 4));
  const m = Number(heute.slice(5, 7));
  if (m >= 8) return { nr: 1, von: `${j}-08-01`, bis: `${j + 1}-01-31` };
  if (m === 1) return { nr: 1, von: `${j - 1}-08-01`, bis: `${j}-01-31` };
  return { nr: 2, von: `${j}-02-01`, bis: `${j}-07-31` };
}

export function zeitFortschritt(heute: LocalDate): FortschrittBalken[] {
  const wochentag = tage(startOfWeek(heute), heute);
  const monatTage = tage(startOfMonth(heute), endOfMonth(heute));
  const monatTag = tage(startOfMonth(heute), heute);
  const j = heute.slice(0, 4);
  const jahrTage = tage(`${j}-01-01`, `${j}-12-31`);
  const jahrTag = tage(`${j}-01-01`, heute);
  const h = schulhalbjahr(heute);
  const hGesamt = tage(h.von, h.bis);
  const hTag = tage(h.von, heute);
  const prozent = (a: number) => `${Math.round(a * 100)} %`;
  return [
    { key: 'woche', label: 'Woche', anteil: wochentag / 7, text: `Tag ${wochentag} von 7` },
    { key: 'monat', label: 'Monat', anteil: monatTag / monatTage, text: prozent(monatTag / monatTage) },
    { key: 'jahr', label: 'Jahr', anteil: jahrTag / jahrTage, text: prozent(jahrTag / jahrTage) },
    { key: 'halbjahr', label: `${h.nr}. Schulhalbjahr`, anteil: hTag / hGesamt, text: prozent(hTag / hGesamt) },
  ];
}
